/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const SatispayR = t.interface({});

// optional attributes
const SatispayO = t.partial({
  hasMore: t.boolean,

  token: t.string,

  uidSatispay: t.string,

  uidSatispayHash: t.string
});

export const Satispay = t.intersection([SatispayR, SatispayO], "Satispay");

export type Satispay = t.TypeOf<typeof Satispay>;
